/* global axios */
import ApiClient from './ApiClient';

class NotificationSubscriptions extends ApiClient {
  constructor() {
    super('notification_subscriptions');
  }

  removeSubscription(params) {
    return axios.delete(this.url, { params, timeout: 5000 });
  }
}

export default new NotificationSubscriptions();
